import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import * as qs from 'qs';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment.prd';
import { fixLocale } from '../models/supported-language.model';

type TranslationItem = { key: string; value: string };
type TranslationData = { items: TranslationItem[] };
type CMSResonse<T> = {
  data: T[];
};

class StrapiTranslateLoader implements TranslateLoader {
  private readonly HTTP_HEADERS = new HttpHeaders({
    Authorization: `Bearer ${environment.cms.apiToken}`,
  });
  private readonly apiUrl = environment.cms.apiUrl;
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<{ [key: string]: string }> {
    const queryLocale = fixLocale(lang);
    const params = {
      filters: {
        name: {
          $eq: 'Portal',
        },
        locale: {
          $eq: queryLocale,
        },
      },
      fields: ['name'],
      populate: 'items',
    };
    const query = qs.stringify(params, { encodeValuesOnly: true });

    const url = `${this.apiUrl}/translations?${query}`;

    return this.http
      .get<CMSResonse<TranslationData>>(url, { headers: this.HTTP_HEADERS })
      .pipe(
        map((response: CMSResonse<TranslationData>) => {
          const translations: { [key: string]: string } = {};
          if (
            response &&
            response.data &&
            response.data.length > 0 &&
            response.data[0].items &&
            response.data[0].items.length > 0
          ) {
            response.data[0].items.forEach((item: TranslationItem) => {
              if (item.key && item.value) {
                translations[item.key] = item.value;
              }
            });
          }
          return translations;
        })
      );
  }
}

export function createStrapiTranslateLoader(http: HttpClient) {
  return new StrapiTranslateLoader(http);
}
